import React, { useState } from 'react';

import { Form } from 'react-bootstrap';

import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    Avatar,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const AddWorkNote = ({ open, onClose }) => {

    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm" >
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>

                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily:'Manrope' }}>Add work note</Typography>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box>
                        <Form.Label style={{ fontSize: '16px', fontWeight: '600', color: '#1A1F36', marginBottom: '0', fontFamily:'Manrope' }}>Note</Form.Label>
                        <TextField placeholder="Write a note..." fullWidth multiline rows={5} sx={{ mb: 3, fontSize: '14px', borderRadius: '6px', margin: '4px auto', fontFamily:'Manrope', '& MuiInputBase-input':{fontFamily:'Manrope'} }} />
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px', borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily:'Manrope' }}>
                        Close
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily:'Manrope' }}>
                        Add Notes
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default AddWorkNote;
